import { adminsConstants } from "../_constants";

export default function adminUsers(state = {}, action) {
    switch (action.type) {
        case adminsConstants.GET_ADMIN_USER_LIST_REQUEST:
            return {
                ...state,
                loading: true
            };
        case adminsConstants.GET_ADMIN_USER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                adminUsersList: action?.user
            };
        case adminsConstants.GET_ADMIN_USER_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        default:
            return state
    }
}